import { Box, Button, Flex, Radio, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck } from "@tabler/icons-react";
import { useState } from "react";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";

/**
 * Đánh dấu / bỏ đánh dấu các sản phẩm đã chọn là gói bảo hành mở rộng (BHMR).
 * Backend ghi tbl_item.attribute57 = 1 khi là gói BHMR, xoá về null khi bỏ đánh dấu.
 */
const UpdateBhmrPackage = ({
  ids,
  onSuccess,
}: {
  ids: string[];
  onSuccess: any;
}) => {
  const [visible, { open, close }] = useDisclosure(false);
  const [value, setValue] = useState<string>("1");

  const handleUpdate = async () => {
    if (!ids || ids.length === 0) {
      NotificationExtension.Fails("Vui lòng chọn ít nhất một sản phẩm !");
      return;
    }

    open();
    try {
      const res = await repositoryPos.post<MessageResponse<any>>(
        "/api/v1/TblItem/update-bhmr-package",
        { ids: ids.map(Number), value: Number(value) }
      );

      if (res && res.success) {
        NotificationExtension.Success(res.message || "Cập nhật thành công !");
        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1000);
      } else if (res) {
        NotificationExtension.Fails(res.message ?? "Cập nhật thất bại !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  return (
    <Box size={"auto"}>
      <Text size="16px" mt={10} fw={500}>
        Cập nhật cho <b>{ids?.length ?? 0}</b> sản phẩm đã chọn:
      </Text>
      <Radio.Group mt={15} value={value} onChange={setValue}>
        <Stack gap="xs">
          <Radio value="1" label="Là gói bảo hành mở rộng (BHMR)" />
          <Radio value="0" label="Không phải gói BHMR" />
        </Stack>
      </Radio.Group>
      <Flex justify="center" mt={20}>
        <Button
          color="teal"
          disabled={visible}
          loading={visible}
          onClick={handleUpdate}
          leftSection={<IconCheck size={18} />}
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default UpdateBhmrPackage;
